'use strict';
/**
 * fetch APIでフロントエンドからAPIを叩く処理をまとめたオブジェクト
 */
export const HttpRequest = {
  default_get_option: {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/html; charset=utf-8',
    },
  },
  createQueryString(params = {}) {
    if (Object.keys(params).length === 0) { return ''; }

    return '?' + Object.entries(params).map((element) => `${element[0]}=${element[1]}`).join('&');
  },
  /**
   * fetch APIでフロントエンドからAPIを叩く処理をまとめたオブジェクト
   * @param {string} url エンドポイント
   * @param {object} params クエリパラメータ
   * @param {object} option method, credentials, headerのオプション。指定がなければデフォルトのオプションを使用する
   */
  async get(url = ``, params = {}, option = {}) {
    const init = Object.assign(this.default_get_option, option);
    const response = await fetch(`${url}${this.createQueryString(params)}`, init);
    return response;
  },
  default_post_option: {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  },
  /**
   * fetch APIでフロントエンドからAPIを叩く処理をまとめたオブジェクト
   * @param {string} url エンドポイント
   * @param {object} data リクエストボディ
   * @param {object} option method, credentials, headerのオプション。指定がなければデフォルトのオプションを使用する
   */
  async post(url = ``, data = {}, option = {}) {
    const init = Object.assign(this.default_post_option, option, { body: JSON.stringify(data) });
    const response = await fetch(url, init);
    return response;
  },
  default_delete_option: {
    method: 'DELETE',
    credentials: 'same-origin',
  },
  /**
   * fetch APIでフロントエンドからAPIを叩く処理をまとめたオブジェクト
   * @param {string} url エンドポイント
   * @param {object} option method, credentials, headerのオプション。指定がなければデフォルトのオプションを使用する
   */
  async delete(url = ``, option = {}) {
    const init = Object.assign(this.default_delete_option, option);
    const response = await fetch(url, init);
    return response;
  },
};